import { IsiEvents } from "../Events/IsiEvents";

export class IsiControlEvents extends IsiEvents {

    
}